module.exports = __webpack_public_path__ + "static/00052.164e94be.jpg";